export default __webpack_public_path__ + "static/media/5.535cfd5a.png";